/**
 * Customer ban list API client
 */
import { api } from '../services/api';

export type BanType = 'name' | 'email' | 'address';

export interface CustomerBan {
  id: string;
  ban_type: BanType;
  display_value: string;
  normalized_value: string;
  address_json?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postal_code?: string;
    country?: string;
  } | null;
  reason?: string | null;
  source_order_id?: string | null;
  active: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
  deactivated_at?: string | null;
}

export interface OrderBanPreview {
  order_id: string;
  external_id: string;
  source: string;
  buyer_name?: string | null;
  buyer_email?: string | null;
  shipping_address?: string | null;
  shipping_address_json?: Record<string, string | undefined> | null;
  available_ban_types: BanType[];
}

export interface BanFromOrderResult {
  created: CustomerBan[];
  skipped: Array<{ ban_type: string; reason: string }>;
}

export async function listCustomerBans(active = true): Promise<CustomerBan[]> {
  const response = await api.get('/customer-bans', { params: { active } });
  return response.data as CustomerBan[];
}

export async function createCustomerBan(payload: {
  ban_type: BanType;
  display_value: string;
  address_json?: Record<string, string | undefined>;
  reason?: string;
}): Promise<CustomerBan> {
  const response = await api.post('/customer-bans', payload);
  return response.data as CustomerBan;
}

export async function createBansFromOrder(payload: {
  order_id: string;
  ban_types?: BanType[];
  reason?: string;
}): Promise<BanFromOrderResult> {
  const response = await api.post('/customer-bans/from-order', payload);
  return response.data as BanFromOrderResult;
}

export async function previewOrderForBan(orderId: string): Promise<OrderBanPreview> {
  const response = await api.get(`/customer-bans/order-preview/${orderId}`);
  return response.data as OrderBanPreview;
}

export async function deactivateCustomerBan(banId: string): Promise<CustomerBan> {
  const response = await api.patch(`/customer-bans/${banId}`, { active: false });
  return response.data as CustomerBan;
}
